export default __webpack_public_path__ + "static/media/Kerry.82a19b9d.jpg";